module.exports = __webpack_public_path__ + "img/last-winner-graphic.ee05e563.png";